// extracted by mini-css-extract-plugin
export var button = "_88-0";
export var icon = "_88-1";